module.exports = __webpack_public_path__ + "img/KCAE.8e5863eb.png";